import api from "../../axiosConfig";

export const addVitals = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/vital/add-update-vital', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getVitals = async (appointment_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get(`/vital/get-vital/${appointment_id}`);
    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
    // if(resData?.pulse)
    //   return resData;
    // else
    //   return null;  
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};

